interface TextInputProps {
  title: string;
  placeholder: string;
  state: string;
  setState: React.Dispatch<React.SetStateAction<string>>;
}

const TextInput: React.FC<TextInputProps> = ({
  title,
  placeholder,
  state,
  setState,
}) => {
  return (
    <div className="self-stretch h-fit flex-col justify-start items-start gap-1.5 flex">
      <div className="text-neutral-500 text-xs font-normal font-sans uppercase leading-[14px] tracking-wide">
        {title}
      </div>
      <div className="self-stretch bg-neutral-50 rounded-lg justify-start items-center">
        <input
          type="text"
          value={state}
          onChange={(event) => setState(event.target.value)}
          className="w-full h-full p-3 text-neutral-700 placeholder:text-neutral-300 text-base font-sans leading-[19px] bg-transparent border-none focus:outline-none"
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default TextInput;
